import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { InMemoryScrollingFeature, InMemoryScrollingOptions, provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor, AuthStateService, ErrorInterceptor, NavigationService } from '@sml/utility';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '@env/environment';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};
const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, inMemoryScrollingFeature, withRouterConfig({ paramsInheritanceStrategy: "always" })),
    provideHttpClient(
      withFetch(),
      withInterceptors([ErrorInterceptor]),
      withInterceptorsFromDi()
    ),
    provideAnimationsAsync(),
    provideAuth0({
      domain: 'seemylegacy.us.auth0.com',
      clientId: 'RACKNXT0HxGd3cZCMgECKEeqp6UmPtzj',
      authorizationParams: {
        redirect_uri: `${environment.webUrl}/callback`,
        //redirect_uri: `${window.location.origin}/callback`,
        audience: 'https://seemylegacy.us.auth0.com/api/v2/',
        scope: 'openid profile email',
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      inject(NavigationService);
      inject(AuthStateService);
    }),
  ],
};
